import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const parseDate = (dateStr) => {
  if (!dateStr) return null;
  const strict = dayjs.utc(dateStr, "DD/MM/YYYY", true);
  if (strict.isValid()) return strict.valueOf();
  const iso = dayjs.utc(dateStr);
  return iso.isValid() ? iso.valueOf() : null;
};

export const reformatDate = (
  dateStr,
  outputFormat,
  inputFormat = "DD/MM/YYYY HH:mm",
) => {
  const d = dayjs.utc(dateStr, inputFormat, true);
  return d.isValid() ? d.format(outputFormat) : "";
};

export const formatTsMonthYear = (ts) => {
  if (ts == null || isNaN(ts)) return "";
  return dayjs.utc(ts).format("MM/YYYY");
};

export const formatTsDayMonth = (ts) => {
  if (ts == null || isNaN(ts)) return "";
  return dayjs.utc(ts).format("D/M");
};

export const formatTsDayMonthYear = (ts) => {
  if (ts == null || isNaN(ts)) return "";
  return dayjs.utc(ts).format("DD/MM/YYYY");
};

export const formatTsShortMonth = (ts) => {
  if (ts == null || isNaN(ts)) return "";
  const d = dayjs.utc(ts);
  return d.month() === 0 ? `Th1-${d.year()}` : `Th${d.month() + 1}`;
};

export const formatMonthYear = (dateStr) => formatTsMonthYear(parseDate(dateStr));

export const subtractFromTs = (ts, amount, unit) =>
  dayjs.utc(ts).subtract(amount, unit).valueOf();

export const addToTs = (ts, amount, unit) =>
  dayjs.utc(ts).add(amount, unit).valueOf();

export const yearsSinceTs = (ts) => {
  if (ts == null || isNaN(ts)) return null;
  return dayjs.utc().diff(dayjs.utc(ts), "year");
};

export const getTsYear = (ts) => {
  if (ts == null || isNaN(ts)) return null;
  return dayjs.utc(ts).year();
};

export const isToday = (dateStr) => {
  const ts = parseDate(dateStr);
  return ts ? dayjs.utc(ts).isSame(dayjs.utc(), "day") : false;
};

export const relativeDayLabel = (dateStr) => {
  const ts = parseDate(dateStr);
  if (ts == null) return "";
  const days = dayjs.utc().startOf("day").diff(dayjs.utc(ts).startOf("day"), "day");
  if (days <= 0) return "Hôm nay";
  if (days === 1) return "Hôm qua";
  return `${days} ngày trước`;
};
